module.exports = __webpack_public_path__ + "static/media/cta.dd76e5c2.png";